<template>
  <div
    class="skeleton-loader"
    :class="{ 'skeleton-compact': compact }"
  >
    <div
      v-if="type === 'widget'"
      class="skeleton-widget"
    >
      <div class="skeleton-line skeleton-title" />
      <div class="skeleton-line skeleton-value" />
      <div
        v-if="showTable && !compact"
        class="skeleton-table"
      >
        <div class="skeleton-line skeleton-table-header" />
        <div class="skeleton-line skeleton-table-row" />
        <div class="skeleton-line skeleton-table-row" />
        <div class="skeleton-line skeleton-table-row" />
      </div>
    </div>
    <div
      v-else-if="type === 'dashboard'"
      class="skeleton-dashboard"
    >
      <div
        v-for="i in 2"
        :key="i"
        class="skeleton-section"
      >
        <div class="skeleton-line skeleton-section-title" />
        <div class="skeleton-grid">
          <div
            v-for="j in 6"
            :key="j"
            class="skeleton-card"
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="skeleton-default"
    >
      <div class="skeleton-line" />
      <div class="skeleton-line" />
      <div class="skeleton-line skeleton-short" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  type: {
    type: String,
    default: 'default', // 'default', 'widget', 'dashboard'
    validator: (value) => ['default', 'widget', 'dashboard'].includes(value)
  },
  showTable: {
    type: Boolean,
    default: false
  },
  compact: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.skeleton-loader {
  width: 100%;
  height: 100%;
  padding: 8px 0;
  min-height: 0;
  overflow: hidden;
}

.skeleton-line {
  background: linear-gradient(
    90deg,
    #f0f0f0 0%,
    #e0e0e0 50%,
    #f0f0f0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 4px;
  height: 16px;
  margin-bottom: 12px;
}

.skeleton-title {
  width: 60%;
  height: 20px;
  margin-bottom: 16px;
}

.skeleton-value {
  width: 80%;
  height: 32px;
  margin-bottom: 20px;
}

.skeleton-short {
  width: 40%;
}

.skeleton-table {
  margin-top: 20px;
}

.skeleton-table-header {
  width: 100%;
  height: 20px;
  margin-bottom: 12px;
}

.skeleton-table-row {
  width: 100%;
  height: 16px;
  margin-bottom: 8px;
}

.skeleton-widget {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Compact mode for focused widgets (112px row height) */
.skeleton-loader.skeleton-compact {
  padding: 0;
  margin-top: -4px;
}

.skeleton-compact .skeleton-title {
  height: 14px;
  margin-bottom: 8px;
}

.skeleton-compact .skeleton-value {
  height: 20px;
  margin-bottom: 0;
}

.skeleton-dashboard {
  width: 100%;
  padding: 20px 0;
}

.skeleton-section {
  width: 100%;
  margin-bottom: 40px;
}

.skeleton-section-title {
  width: 200px;
  height: 24px;
  margin-bottom: 20px;
}

.skeleton-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;
}

.skeleton-card {
  background: linear-gradient(
    90deg,
    #f0f0f0 0%,
    #e0e0e0 50%,
    #f0f0f0 100%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s ease-in-out infinite;
  border-radius: 12px;
  height: 240px;
}

@media (max-width: 768px) {
  .skeleton-grid {
    grid-template-columns: 1fr;
  }
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style>
